import { render, staticRenderFns } from "./vat-address.vue?vue&type=template&id=5252c37c&lang=pug"
import script from "./vat-address.vue?vue&type=script&lang=ts"
export * from "./vat-address.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports